import PropTypes from 'prop-types';

const ReportChartOverlay = ({ label }) => <div className="text-gray-600 top-0 left-0 w-full h-full bg-white/50 flex absolute z-50 justify-center items-center backdrop-blur-sm">{label}</div>;

ReportChartOverlay.propTypes = {
  label: PropTypes.string.isRequired,
};

export default ReportChartOverlay;
